import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-webpage-hosting',
  templateUrl: './webpage-hosting.component.html',
  styleUrls: ['./webpage-hosting.component.scss']
})
export class WebpageHostingComponent implements OnInit {
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`;
  constructor() { }

  ngOnInit(): void {}

}
